import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { SitesRouteNames, SitesRoutePathNames } from '../../../../enums';

const Component = () => import('./CentricPOS.vue');

export default {
  path: buildChildURL(SitesRoutePathNames.CENTRIC_POS),
  name: SitesRouteNames.SITE_CENTRIC_POS,
  component: Component,
} as RouteRecordRaw;
